<template>
  <div class="cruella-dewalt slide">
    <HorizontalAnimation :animation="animation" :loop=false />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">STORE 1763</p>
      <h1>Cruella DeWalt</h1>
      <p>At store 1763, an individual identified as <strong>Cruella DeWalt</strong> has been apprehended and charged with grand larceny. CCTV footage of DeWalt exiting an orange pickup suggests she may be tied to the vanity stuffing crew.</p>
    </div>
    <router-link to="/trivia-11">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import CruellaDeWalt from '@/assets/cruella.js'

export default {
  name: 'cruella-dewalt',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: CruellaDeWalt
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top: 20px;
  }
</style>
